import type { SxProps, Theme } from '@mui/material/styles';

export const hcpMetaData = {
	root: {
		pb: 1,
		borderRadius: 1,
		minWidth: 0,
		flex: 1
	},

	bodyRow: {
		display: 'grid',
		gridTemplateColumns: { md: '1fr auto' },
		gap: { xs: 1, md: 0 },
		px: 2
	},

	headerGrid: {
		display: 'grid',
		gridTemplateColumns: 'minmax(0, 1fr) auto',
		columnGap: 7.5,
		rowGap: 0.5,
		px: 2,
		pt: 2
	},

	breadcrumbVisibility: {
		display: { xs: 'none', sm: 'contents' }
	},

	breadcrumbCell: {
		gridColumn: { xs: '1 / -1', md: 1 },
		minWidth: 0
	},

	nameCell: {
		gridColumn: '1 / -1',
		minWidth: 0,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		justifyContent: 'center'
	},

	name: {
		lineHeight: '130%',
		letterSpacing: '0px',
		fontSize: '1.5rem',
		fontWeight: 700
	},
	veevaIdContainer: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		gap: 0.5
	},

	veevaIdLabel: {
		color: 'text.secondary',
		textAlign: 'center',
		fontSize: '0.75rem'
	},

	copyIcon: {
		fontSize: '.75rem'
	},

	copyButton: {
		my: '-6px',
		mr: '-6px'
	},

	nameInfoContainer: {
		flexDirection: 'column',
		display: 'flex',
		alignItems: 'flex-start',
		justifyContent: 'center',
		px: 2,
		flex: 1,
		minWidth: 0
	} as SxProps<Theme>,

	leftColumn: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		minWidth: 0,
		gridColumn: { md: 1 },
		gridRow: { md: 1 },
		order: { xs: 0, md: 1 }
	},

	rightColumn: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: { xs: 'flex-start', md: 'flex-end' },
		gap: 0.5,
		gridColumn: { md: 2 },
		gridRow: { md: 1 },
		alignSelf: { md: 'end' },
		order: { xs: 1, md: 0 }
	},

	statusLabel: {
		color: 'text.secondary',
		fontSize: '12px'
	}
};
